export const INotificationsKyc = Object.freeze({
  additionalFileRequired: "kyc_additional_file_required",
  activationRequired: "kyc_activation_required",
});

export class NotificationsKycModel {
  constructor(data = {}) {
    this[INotificationsKyc.additionalFileRequired] = data[INotificationsKyc.additionalFileRequired];
    this[INotificationsKyc.activationRequired] = data[INotificationsKyc.activationRequired];
  }

  isAdditionalFileRequired() {
    return this[INotificationsKyc.additionalFileRequired];
  }

  isKycActivationRequired() {
    return this[INotificationsKyc.activationRequired];
  }
}
